<template>
  <el-container class="home-container">
    <!-- 头部区域 -->
    <el-header>
      <div>
        <img class="logo" src="../assets/logo.png" alt="" />
        <span>后台管理系统</span>
      </div>
      <div class="userInfo">登陆账号：{{ phone }}</div>
      <el-button type="info" @click="xgpassword(phone)">修改密码</el-button>
      <el-button type="info" @click="logout">退出</el-button>
    </el-header>

    <!-- 页面主体区域 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <!-- 侧边栏菜单区域 -->
        <el-menu background-color="#333744" text-color="#fff" active-text-color="#409EFF" unique-opened :collapse="isCollapse" :collapse-transition="false" router :default-active="activePath">
          <!-- 一级菜单 -->
          <el-submenu :index="item.id + ''" v-for="item in menulist" :key="item.id">
            <!-- 一级菜单的模板区域 -->
            <template slot="title">
              <!-- 图标 -->
              <i :class="iconsObj[item.id]"></i>
              <!-- 文本 -->
              <span>{{ item.name }}</span>
            </template>

            <!-- 二级菜单 -->
            <el-menu-item :index="'/' + subItem.path" v-for="subItem in item.children" :key="subItem.id" @click="saveNavState('/' + subItem.path)">
              <template slot="title">
                <!-- 图标 -->
                <i class="el-icon-menu"></i>
                <!-- 文本 -->
                <span>{{ subItem.name }}</span>
              </template>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 右侧内容主体 -->
      <el-main>
        <!-- 路由占位符 -->
        <router-view></router-view>
        <el-dialog title="修改密码" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
        <el-form :model="editForm" :rules="addFormRules" ref="editFormRef" label-width="130px">
          <el-form-item label="登陆密码" prop="password">
            <el-input v-model="editForm.password"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editUserInfo">确 定</el-button>
        </span>
      </el-dialog>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      phone: null,
      // 左侧菜单数据
      menulist: [],
      twoMenulist: [],
      iconsObj: {
        '1': 'iconfont icon-user',
        '2': 'iconfont icon-tijikongjian',
        '3': 'iconfont icon-shangpin',
        '4': 'iconfont icon-danju',
        '5': 'iconfont icon-baobiao',
        '6': 'iconfont icon-baobiao',
        '7': 'iconfont icon-baobiao',
        '8': 'iconfont icon-baobiao',
        '9': 'iconfont icon-lock_fill',
      },
      // 是否折叠
      isCollapse: false,
      // 被激活的链接地址
      activePath: '',
      role: 0,//1管理员2经销商
      // 控制修改用户对话框的显示与隐藏
      editDialogVisible: false,
      // 查询到的用户信息对象
      editForm: {
        id: '',
        phone: '',
        password: '',
        name: '',
        role: null,
      },
    }
  },
  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
    this.role = window.sessionStorage.getItem('role')
    this.getMenuList()
  },


  methods: {
    logout () {
      window.sessionStorage.clear()
      window.localStorage.clear()
      this.$router.push('/login')
    },
    //获取用户信息
    async xgpassword(value){
       const { data: res } = await this.$http.get('admin/managed/baseManagedInfo', {
        params: { phone: value }
      })
      if (res.code !== 200) {
        return this.$message.error('查询用户信息失败！')
      }
      this.editForm = res.result
      this.editDialogVisible = true
    },
    // 修改用户信息并提交
    editUserInfo () {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        // 发起修改用户信息的数据请求
        const { data: res } = await this.$http.post(
          'admin/managed/editManagedinfo',
          this.editForm
        )
        if (res.code !== 200) {
          return this.$message.error('更新用户信息失败！')
        }

        // 关闭对话框
        this.editDialogVisible = false
        // 刷新数据列表
        this.getUserList()
        // 提示修改成功
        this.$message.success('更新用户信息成功！')
      })
    },

    // 获取所有的菜单
    async getMenuList () {
      this.phone = window.sessionStorage.getItem('phone');
      if (!this.phone) {
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      const { data: res } = await this.$http.post('admin/user/getUseruthority', {
        phone: this.phone,
        role: this.role
      })
      if (res.code !== 200) return this.$message.error(res.meta.msg)
      this.menulist = res.result

      var twolist = [];
      if (res.result) {
        res.result.forEach(ele => {
          ele.children.forEach(ele1 => {
            twolist.push(ele1)
          })
        })
        window.sessionStorage.setItem('twoMenulist', twolist);
      }
      this.twoMenulist = twolist
      var path = this.activePath;
      console.log('数据2',path);
      if (path!=''&&path!=null) {
        this.twoMenulist.forEach(ele => {
          // console.log(ele.path);
          if (ele.path == path.substring(1, path.length)) {
            window.sessionStorage.setItem('pathCanLook', ele.canLook)
          }
        })
      }
    },

    // 点击按钮，切换菜单的折叠与展开
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },

    // 点击二级菜单，保存链接的激活状态
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      // console.log(activePath.substring(1, activePath.length));
      this.twoMenulist.forEach(ele => {
        // console.log(ele);
        if (ele.path == activePath.substring(1, activePath.length)) {
          window.sessionStorage.setItem('pathCanLook', ele.canLook)
        }
      })
      this.activePath = activePath
    },
    editDialogClosed(){

    },
    addFormRules(){

    }
  }
}
</script>

<style lang="less" scoped>
.home-container {
  height: 100%;
}
.logo {
  width: 200px;
  height: 60px;
}

.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}

.userInfo {
  font-size: 16px;
}

.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
  }
}

.el-main {
  background-color: #eaedf1;
}

.iconfont {
  margin-right: 10px;
}

.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;
}
</style>
